{
  "groups": [
    {
      "title": "Professional Certifications",
      "items": [
        "ISTQB CTAL Test Manager",
        "ISTQB CTAL Technical Test Analyst",
        "ISTQB CTFL Agile Tester",
        "ISTQB CTFL",
        "ISTQB Accredited Trainer (all above)",
        "Certified SAFe® 6 Agilist",
        "AgilePM® Foundation"
      ],
      "icon": "Award",
      "accent": "cyan"
    },
    {
      "title": "AI & Emerging Tech",
      "items": [
        "AI_devs 3 Agents",
        "Fundamentals of Artificial Intelligence and Machine Learning for IT Specialists and Managers"
      ],
      "icon": "BrainCircuit",
      "accent": "purple"
    },
    {
      "title": "Additional Training",
      "items": [
        "15+ technical courses (Pluralsight, Udemy) covering Java, CI/CD, Big Data, API testing"
      ],
      "icon": "BookOpen",
      "accent": "emerald"
    }
  ]
}
